import { useEffect, useMemo, useState } from "react";
import { useRouteMatch } from "react-router";
import { Link, TableCell, TableRow, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DeleteOutline as TrashIcon } from "@mui/icons-material";
import { filter } from "lodash";

import useCatalogDetail, { INewCustomPanel } from "hooks/useCatalogDetail";
import { colors } from "theme";
import { CnvStatus, DesignType, Workflow } from "types/design";
import { IDesignDetail } from "types/designDetail";

import Switch from "./Swtich";

const useStyles = makeStyles((theme: Theme) => ({
  row: {
    background: colors.grey[700],
    "& > .MuiTableCell-root": {
      borderBottom: "none",
      fontSize: 12,
      lineHeight: "17.5px",
      padding: "11px 13px 11px 16px",
      width: ({ workflow }: any) =>
        workflow === Workflow.FUSION ? "20%" : "25%",
    },
    "&.old-row": {
      background: colors.grey[700],
      transition: "background 5000ms linear",
    },
  },
  groupSpacing: {
    height: 16,
  },
}));

const Row = ({
  detailGroup,
  workflow,
  cnv,
  cnvToggle = false,
  isOnDetail = true,
}: {
  detailGroup: IDesignDetail[];
  workflow: Workflow;
  cnv: boolean;
  cnvToggle?: boolean;
  isOnDetail?: boolean | number;
}) => {
  const [isNew, setIsNew] = useState<boolean>(true);
  const { catalog, setNewDetails } = useCatalogDetail();
  const classes = useStyles({ workflow, isNew });
  const { path } = useRouteMatch();

  const isGeneModuleDetailRow = useMemo(() => {
    return (
      catalog?.designType === DesignType.GENE_MODULE &&
      path === "/catalog/detail/:id"
    );
  }, [path, catalog?.designType]);

  useEffect(() => {
    setTimeout(() => setIsNew(false), 3000);
  }, []);

  return (
    <>
      {detailGroup.map((row: IDesignDetail, index: number) => (
        <TableRow
          key={row.id}
          className={`${classes.row} ${isNew ? "" : "old-row"}`}
        >
          <TableCell>{row.gene}</TableCell>
          <TableCell>{row.accession}</TableCell>
          <TableCell>{row.exon}</TableCell>
          {workflow === Workflow.FUSION && (
            <>
              <TableCell>{row.assayType}</TableCell>
              <TableCell>{row.description}</TableCell>
            </>
          )}
          {(index === 0 ||
            detailGroup[index - 1].gene !== detailGroup[index].gene) &&
            workflow !== Workflow.FUSION && (
              <TableCell
                rowSpan={
                  filter(detailGroup, ["gene", detailGroup[index].gene]).length
                }
              >
                <Switch
                  checked={
                    detailGroup[index].cnv !== CnvStatus.YES_NO
                      ? detailGroup[index].cnv === CnvStatus.YES
                      : cnv
                  }
                  disabled={!cnvToggle}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setNewDetails((designs: Map<number, INewCustomPanel>) => {
                      const designId = isOnDetail as number;

                      designs.set(designId, {
                        cnv: event.target.checked,
                        cnvToggle,
                        designDetails:
                          designs.get(designId)?.designDetails || [],
                      });
                      return new Map(designs);
                    });
                  }}
                  {...(isGeneModuleDetailRow &&
                    detailGroup[index].cnv === CnvStatus.YES_NO && {
                      label: "Yes/No",
                    })}
                />
              </TableCell>
            )}
          {index === 0 && isOnDetail !== true && (
            <TableCell rowSpan={detailGroup.length}>
              <Link
                component="button"
                onClick={() =>
                  setNewDetails((designs: Map<number, INewCustomPanel>) => {
                    designs.delete(isOnDetail as number);
                    return new Map(designs);
                  })
                }
              >
                <TrashIcon color="primary" />
              </Link>
            </TableCell>
          )}
        </TableRow>
      ))}
      <TableRow className={classes.groupSpacing} />
    </>
  );
};

export default Row;
